import { getTranslation } from '@amo/core/utils/functions.js';

/**
 * Impasse du parcours déjà client : le contrat repris ne peut plus être décliné en l'état, on
 * renvoie sur une souscription neuve. La mise en forme se règle par className, les étapes n'ayant
 * pas toutes le même gabarit d'erreur : sous le champ pour une question à saisie, en bandeau pour
 * une question à choix.
 */
export const AlerteNouvelleSouscription = (props) => {
    const { message, className = 'alert alert-danger mt-3 col-lg-8 offset-lg-2' } = props;

    return (
        <div className={className} role={'alert'}>
            <span dangerouslySetInnerHTML={{ __html: message }} />
            <button
                type={'button'}
                className={'d-block mx-auto mt-2 bg-transparent border-0 p-0 text-reset text-decoration-underline fw-bold'}
                onClick={() => {
                    // Session vierge : sans ça le localStorage rejouerait le devis déjà client
                    window.localStorage.clear();
                    window.location.href = window.location.origin;
                }}
            >
                {getTranslation('restartQuote')}
            </button>
        </div>
    );
};
